import React, { useEffect } from 'react';
import styles from './index.module.scss';
import { useParams } from 'react-router';
import { usePageView, useTimeOnPage } from '@cvte/react-fridayagent3';
import FRIDAYAGENT_EVENTS from 'constant/fridayAgentEvent';
import SingleRoomScheduleTable from 'component/SingleRoomScheduleTable';
import Breadcrumb from 'component/Breadcrumb';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'model';
import { getRoomDetail, setRoomDetail } from 'model/room';

const RoomDetail: React.FC = () => {
  const dispatch = useDispatch();
  const params: { id: string } = useParams();
  const roomDetail = useSelector((state: RootState) => state.room.roomDetail);

  useEffect(() => {
    dispatch(getRoomDetail(params.id));

    return () => {
      dispatch(setRoomDetail(null));
    };
  }, []);

  // 埋点
  usePageView({ ...FRIDAYAGENT_EVENTS.WEB_TEAMS_PAGEVIEW_ROOM_DETAIL, data: { room_id: params.id } });
  useTimeOnPage({ ...FRIDAYAGENT_EVENTS.WEB_TEAMS_TIMEONPAGE_ROOM_DETAIL, data: { room_id: params.id } });

  return roomDetail && roomDetail.id === params.id ? (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <Breadcrumb items={[{ path: '/schedule', label: '会议室' }, { label: ' 会议室详情' }]}></Breadcrumb>
      </div>
      <SingleRoomScheduleTable room={roomDetail} />
    </div>
  ) : (
    <></>
  );
};

export default RoomDetail;
